import * as qs from 'query-string';
import * as _ from 'lodash';
import { FormEvent, useEffect, useState } from 'react';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, AppActionCreators, SwapQualityIssueActionCreators, ISwapQualityIssueResponse, ISwapQualityLookupDataResponse } from '@nkr/store/index';
import { IBaseResponse, ISwapQualityIssue } from '@nkr/models/index';
import { SwapQualityIssueListType, SwapQualityIssueReportedBy } from '@nkr/enums/index';
import { Alert, Button, Col, Row } from 'react-bootstrap';
import { SwapQualityIssueWrapper } from './styles';
import { toast } from 'react-toastify';
import SwapInfo from './edit/swap-info';
import DonorInfo from './edit/donor-info';
import RecipientInfo from './edit/recipient-info';

interface IProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getById: (id: number, centerId: number) => Promise<ISwapQualityIssueResponse>,
    getLookupData: () => Promise<ISwapQualityLookupDataResponse>,
    recordNoIssues: (issueId: number, centerId: number) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps

// interface IState {
//     data: ISwapQualityIssue,
//     previous: SwapQualityIssueListType,
//     reportedBy: SwapQualityIssueReportedBy
// }

const SwapQualityIssueNoIssue = (props: TProps) => {
    const [data, setData] = useState<ISwapQualityIssue>(null);
    const [previous, setPrevious] = useState<SwapQualityIssueListType>(null);
    const [reportedBy, setReportedBy] = useState<SwapQualityIssueReportedBy>(null);

    // readonly state: IState = {
    //     data: null,
    //     previous: null,
    //     reportedBy: null
    // }

    // componentDidMount = () => {
    //     getData();
    // }

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        let parsed = qs.parse(location.search);
        let id = parsed.id != null ? parseInt(parsed.id) : 0;
        let previous = parsed.previous != null ? parseInt(parsed.previous) : SwapQualityIssueListType.PendingResponse;
        let reportedBy = parsed.reportedBy != null ? parseInt(parsed.reportedBy) : SwapQualityIssueReportedBy.YourCenter;

        props.showLoading('Getting data, one moment please...').then(() => {
            Promise.all([
                props.getById(id, props.centerId),
                props.getLookupData()
            ])
                .then(([issueResponse, lookupDataResponse]) => {
                    let data = issueResponse.data.results;

                    setData(data);
                    setPrevious(previous);
                    setReportedBy(reportedBy);
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    const getTypes = (data: ISwapQualityIssue) => {
        if (data.isRecipientCenter) {
            return data.recipientSwapQualityIssueTypes;
        } else {
            return data.donorSwapQualityIssueTypes;
        }
    };

    const getReturnLink = () => {
        let hrefPrefix = !props.isAdmin ? `/center/${props.centerId}/action-center/swap-quality-issues/list` : `/admin/swap-quality-issues/list`;

        switch (previous) {
            case SwapQualityIssueListType.PendingResponse: return `${hrefPrefix}/pending-response?reportedBy=${reportedBy}`;
            case SwapQualityIssueListType.IssueReportedIncomplete: return `${hrefPrefix}/issue-reported-incomplete?reportedBy=${reportedBy}`;
            case SwapQualityIssueListType.IssueReportedComplete: return `${hrefPrefix}/issue-reported-complete?reportedBy=${reportedBy}`;
            case SwapQualityIssueListType.NoIssueReported: return `${hrefPrefix}/no-issue-reported?reportedBy=${reportedBy}`;
            case SwapQualityIssueListType.All: return hrefPrefix + `${hrefPrefix}/all?reportedBy=${reportedBy}`;
            default: return `${hrefPrefix}/pending-response?reportedBy=${reportedBy}`;
        }
    };

    const disableSave = () => {
        if (props.centerId == data.recipientCenterId) {
            return data.recipientIssuesFinalized;
        }

        if (props.centerId == data.donorCenterId) {
            return data.donorIssuesFinalized;
        }

        return false;
    };

    const handleSave = (e: FormEvent<any>) => {
        props.showLoading('Updating the swap quality issue, one moment please...').then(() => {
            props.recordNoIssues(data.id, props.centerId)
                .then(response => {
                    if (response.data.success) {
                        toast.success('Saved successfully');
                    }
                })
                .catch(error => {
                })
                .finally(() => {
                    props.hideLoading()
                    getData();
                });
        });
    };

    if (data == null)
        return null;

    const returnLink = getReturnLink();
    const disabled = disableSave();

    return (
        <SwapQualityIssueWrapper className='container' style={{ paddingBottom: 10 }}>
            {(data.isRecipientCenter && data.recipientIssuesFinalized) || (data.isRecipientCenter == false && data.donorIssuesFinalized) && (
                <Alert bsStyle='danger' bsSize='sm'>The swap quality issue has been finalized and cannot be changed.</Alert>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10, marginBottom: 20 }}>
                <h1 className='text-left' style={{ margin: 0 }}>Record No Issue</h1>
                <div className='dropdown pull-right'>
                    <a href={returnLink}>Return to {'previous list'}</a>
                </div>
            </div>

            {!disabled && data.isLatePickup && (
                <Alert bsStyle='danger'>
                    The kidney was picked up more than 30 minutes late.  You must fill out a swap quality report.
                </Alert>
            )}

            <SwapInfo data={data} />

            <div className='row'>
                <div className='col-lg-6' style={{ marginLeft: 0 }}>
                    <div className='container-fluid' style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <DonorInfo data={data} />
                    </div>
                </div>

                <div className='col-lg-6' style={{ marginLeft: 0 }}>
                    <div className='container-fluid' style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <RecipientInfo data={data} />
                    </div>
                </div>
            </div>

            <Row>
                <Col lg={12} style={{ textAlign: 'center' }}>
                    {!disabled ?
                        <>
                            <Button bsStyle='primary' onClick={handleSave}>Confirm - No Issues</Button>
                            <a className='btn btn-link btn-large' href={returnLink}>Cancel</a>
                        </>
                        :
                        <a className='btn btn-link btn-large' href={returnLink}>Return to List</a>
                    }
                </Col>
            </Row>
        </SwapQualityIssueWrapper>
    );
    // }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {}
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getById: (id, centerId) => {
            return dispatch(SwapQualityIssueActionCreators.getById(id, centerId));
        },
        getLookupData: () => {
            return dispatch(SwapQualityIssueActionCreators.getLookupData());
        },
        recordNoIssues: (issueId, centerId) => {
            return dispatch(SwapQualityIssueActionCreators.recordNoIssues(issueId, centerId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps, mapDispatchToProps)(SwapQualityIssueNoIssue)